import {Injectable} from '@angular/core';
import {UrlSegment} from '@angular/router';

@Injectable()
export class RoutingHelperService {
  constructor() {}

  static CreatePosParams(
    fieldNames: string[],
    url: UrlSegment[]
  ): {[name: string]: UrlSegment} {
    if (!url || url.length === 0) {
      return null;
    }
    const parsedSegments = url.map(RoutingHelperService.ParseUrlSegment).flat();
    const posParams = parsedSegments.reduce(
      (acc, curr, ix) => Object.assign(acc, {[fieldNames[ix]]: curr}),
      {}
    );
    // If any id parameter is not numeric than we can't handle the route
    // If any non-id param is numeric than we can't handle the route
    // TODO: replace the naive isId implementation
    const isId = (str) => str && str.toLowerCase().endsWith('id');
    const isNumeric = (str) => /^\d+$/.test(str);
    if (
      Object.entries<UrlSegment>(posParams).some(
        ([k, v]) =>
          (isId(k) && !isNumeric(v.path)) || (!isId(k) && isNumeric(v.path))
      )
    ) {
      return null;
    }
    return posParams;
  }

  private static ParseUrlSegment(
    segment: UrlSegment
  ): UrlSegment | UrlSegment[] {
    const match = segment.path.match(/^(\d+)-?(.*)$/);
    if (!match) {
      return segment;
    }
    if (match.length === 3) {
      return [new UrlSegment(match[1], {}), new UrlSegment(match[2], {})];
    } else {
      return new UrlSegment(match[1], {});
    }
  }
}
